import { showReferenceFileChoiceAction } from 'actions/mainView'
import { isEmpty, noop } from 'lodash'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAssets, getSourceFilesByIds, isDifferentFileRefParamsSelector } from 'selectors'
import { getIncompatibleFileExtensions } from '~/helpers/incompatibleFileExtensions'
import { selectReference } from '~/selectors/select-reference'
import { isVideo } from '~/Util/assets'
import { useCanAddItemToTimeline } from './useCanAddItemToTimeline'

// useAddSourceFileToTimeline - for the "+" button and adding by frameTimeCode. DnD uses uselayerDropHandler.
export const useAddSourceFileToTimeline = (action = noop, sourceFileIds = []) => {
  const canAddItemToTimeline = useCanAddItemToTimeline()
  const allAssets = useSelector(getAssets)
  const files = useSelector(state => getSourceFilesByIds(state, sourceFileIds))
  const isDifferentFileParams = useSelector(
    state => isDifferentFileRefParamsSelector(state, sourceFileIds)
  )
  const { id: referenceFileId } = useSelector(selectReference)
  const dispatch = useDispatch()

  return useCallback(() => {
    const incompatibleExtensions = files.reduce((result, item) => {
      if (isVideo(item)) result.push(...getIncompatibleFileExtensions(item.filetype))
      return result
    }, [])

    const { allValid } = canAddItemToTimeline(incompatibleExtensions, files)

    if (allValid) {
      if (
        isDifferentFileParams
          && sourceFileIds.length > 1
          && (!referenceFileId || isEmpty(allAssets))
      ) {
        dispatch(showReferenceFileChoiceAction({
          visibility: true,
          getAction: () => action(sourceFileIds),
        }))
      } else {
        dispatch(action(sourceFileIds))
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ isDifferentFileParams, sourceFileIds,
    referenceFileId, canAddItemToTimeline, allAssets.length ])
}
